import React from 'react';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import C18Button00 from '../../usa/components/C18Button00'
// import C18MuiFormControl from '../../usa/components/C18MuiFormControl'
// import C18MuiInputLabel from '../../usa/components/C18MuiInputLabel'
// import C18MuiSelect from '../../usa/components/C18MuiSelect'
// import C18MuiMenuItem from '../../usa/components/C18MuiMenuItem'
import {cl,globs} from '../../components/utils/utils';

class Refresh extends React.Component{
  constructor(props) {
    super(props);
    this.props.getValue(props.ind, {type: "refresh"})
//     cl(props)
//     this.props.getValue(props.ind, {type: "scalar"})
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
//     cl("fui select get value")
  }

  onChange=(type,val)=>{
//     cl(type,val)
//     cl(e.target.value)
    this.props.onChange(this.props.ind, {noChange:true,value: "refresh"})
//     this.changed=true// blocks updating
  }

//   componentWillUnmount=()=>{
//     this.subscribe_updateFui.remove()
//   }

  updateFui=()=>{
    if(!this.changed){this.props.getValue(this.props.ind, {type: "refresh"})}
  }

  render(){
    return(
      <div id={this.props?.custom?.infoId} style={{marginBottom:15}}>
        <C18Button00 type="button" className="filled"
        onClick={()=>this.onChange("refresh",{})}>Refresh</C18Button00>
      </div>
    );
  }

}


  export default Refresh ;
